import { CompanyTrackingMode } from '@/types/company.type';
import { AccessLevel, Member } from '@/types/invite-member.type';

export const AUTOMATIC_TRACKING_ACCESS_LEVELS: AccessLevel[] = ['admin', 'manager'];

export const isAutomaticTrackingMode = (
  flowTrackingMode: CompanyTrackingMode | undefined,
  trackingMode: CompanyTrackingMode,
  trackingModeStep: CompanyTrackingMode | string,
  customTrackingModeStep?: string,
) =>
  flowTrackingMode === 'silent'
  || trackingMode === 'silent'
  || trackingModeStep === 'silent'
  || customTrackingModeStep === 'silent';

export const normalizeMemberAccessLevel = (member: Member, isAutomaticTracking: boolean): Member => {
  if (!isAutomaticTracking || member.role !== 'user') return member;
  return { ...member, role: 'manager' };
};

export const defaultInviteMemberRole = (isAutomaticTracking: boolean): AccessLevel =>
  isAutomaticTracking ? 'manager' : 'user';
